/**************************************************
 * Nombre:       Dialogo_Fin
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Button, Grid, Typography} from "@mui/material";
import {WhatsApp} from '@mui/icons-material'


const Dialogo_Fin = ({datos, cerrar, realizado}) => {


    const subirDatos = async () => {

        //WhatsApp

    }


    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{p: 1}}
        >

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center'}}>
                <Typography>Felicidades has terminado el entrenamiento</Typography>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center'}}>
                <Typography>Luis Rosero se pondra en contacto contigo para contestar tus preguntas, inquietudes o
                    ayudarte en este proceso</Typography>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center', marginTop: 3}}>
                <Button
                    onClick={() => subirDatos()}
                    startIcon={<WhatsApp/>}
                >Comunicarme con el ahora</Button>
            </Grid>


        </Grid>
    )

}
export default Dialogo_Fin